export enum TransitTypeEnum {
    Bus = "1",
    Subway = "2",
    SIFerry = "3"
}